var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("BasicEmployeeCard", {
    attrs: {
      firstName: _vm.firstName,
      lastName: _vm.lastName,
      jobTitle: _vm.jobTitle,
      location: _vm.location,
      avatar: _vm.avatar,
      managerId: _vm.managerId,
    },
    on: { removeAccess: _vm.removeManagerAccessToContractor },
    scopedSlots: _vm._u([
      {
        key: "actions",
        fn: function () {
          return [
            _c("UiButton", {
              staticClass: "ml-auto -mr-2.5",
              attrs: { buttonText: "Remove access", variant: "linkButton" },
              on: { click: _vm.removeAccess },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }